import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.7_@parcel+watcher@2.5.1_@types+node@24.1.0_@upstash+redis@1.35.0_@vue+compile_7fce59830cf89b2ec31e1e9286565a79/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45setup_45global from "/vercel/path0/layers/base/middleware/01.setup.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.7_@parcel+watcher@2.5.1_@types+node@24.1.0_@upstash+redis@1.35.0_@vue+compile_7fce59830cf89b2ec31e1e9286565a79/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45setup_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  admin: () => import("/vercel/path0/layers/modules/fubex-auth/middleware/admin.ts"),
  auth: () => import("/vercel/path0/layers/modules/fubex-auth/middleware/auth.ts"),
  inspector: () => import("/vercel/path0/layers/modules/fubex-auth/middleware/inspector.ts")
}